import { render, staticRenderFns } from "./StartDiscountComponent.vue?vue&type=template&id=1cb35ba2&"
import script from "./StartDiscountComponent.vue?vue&type=script&lang=js&"
export * from "./StartDiscountComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports